import { referralSpecialtiesMap } from 'app/core/options/referral-specialties.opts';
import { Prescriber } from 'app/core/models/prescriber.model';

export const determineRecommendedSpeciality = (prescriber: Prescriber) =>
  referralSpecialtiesMap[prescriber.classification] ||
  referralSpecialtiesMap[prescriber.specialization];
